import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useContext,
} from "react";
import { auth, db } from "../firebase-config";
import { signOut, onAuthStateChanged } from "firebase/auth";

import {
  doc,
  collection,
  updateDoc,
  getDoc,
  onSnapshot,
  query,
  orderBy,
} from "firebase/firestore";
import { Jukebox4 } from "./Jukebox4";
import { AutoPlay } from "./AutoPlay";
import { Users } from "./Users";
import { Users2 } from "./Users2";
import { Users4 } from "./Users4";
import { ChatList } from "./ChatList";
import { LoadingAnimation } from "./LoadingAnimation";
import { Chat } from "./Chat";
import { SideBarMenu } from "./SideBarMenu2";
import LiveNightPanel from "./LiveNightPanel";
import ChatV2 from "./ChatV2";
import CallManager from "./VideoCall";
import { rememberPostLoginPanel, consumePostLoginPanel } from "../services/postLoginIntent";
import { Avatar } from "./Avatar";
import { AvatarName } from "./AvatarName";
import Cookies from "universal-cookie";
import { useIsVisible } from "../hooks/useIsVisible";
import { Message_data } from "../context/context";
import "../ManufMuuzbox.scss";
const cookies = new Cookies();

// The post-sign-in games intent is a ONE-SHOT localStorage flag, and more
// than one copy of this app can be alive at once: the launcher page mounts
// a static <r2w-wcmuuzbox> inside a display:none section on EVERY load (a
// second is appended by the template selector), app/index.html carries TWO
// of them, and on Android the Chrome tab that started a Google sign-in
// lives on hidden while the installed PWA opens as a separate instance.
// Whoever consumes the flag first wins — so consumption must be allowed
// ONLY for an instance the user can actually SEE: the browser tab is in
// the foreground AND this component's root element is really laid out on
// screen (a display:none ancestor gives it a null offsetParent). A hidden
// instance leaves the flag alone for the visible one.
const canThisInstanceConsume = (rootEl) => {
  if (typeof document !== "undefined" && document.visibilityState === "hidden") return false;
  if (!rootEl) return false;
  if (rootEl.offsetParent === null) return false;
  const r = rootEl.getBoundingClientRect();
  return r.width > 0 && r.height > 0;
};
export const AppLayoutManuf = ({
  appMode,
  children,
  isAuth,
  setIsAuth,
  setIsInChat,
  setChatId,
  setIsLaunched,
  funcProp,
  client,
  appLayoutMode,
  initialTime = 5,
  navigateToPlaying,
  setNavigateToPlaying,
}) => {
  const ref = useRef();
  const { message, setMessage } = useContext(Message_data);
  const [isInChat2, setIsInChat2] = useState(null);
  const [isInUsers, setIsInUsers] = useState(null);
  const [isInJukebox, setIsInJukebox] = useState(true); // Start on Request page (Jukebox4)
  const [isInAutoPlay, setIsInAutoPlay] = useState(null);
  const [isInHiddenChat, setIsInHiddenChat] = useState(null);
  // The REBUILT chat gets its own panel, opened from its own side-menu item
  // ("New Chat") — fully separate from the legacy chat surfaces so the two
  // can be assessed independently, mounting none of each other's code.
  const [isInChatV2, setIsInChatV2] = useState(null);
  const [isInGames, setIsInGames] = useState(null);
  const [isInChatList, setInChatList] = useState(true);
  const [isEmbedded] = useState(() => new URLSearchParams(window.location.search).get('autolaunch') === 'true');
  const [chatId2, setChatId2] = useState(null);
  const [chatId3, setChatId3] = useState(null);
  const [chatType, setChatType] = useState(null);
  const [trackDetails, setTrackDetails] = useState(null);
  const [isOpen, setIsopen] = useState(false); // sniff if view is desktop or mobile
  const [avatars, setAvatars] = useState({});
  const [userObject, setUserObject] = useState({});
  const [chatUserObject, setChatUserObject] = useState({});
  const [chatUsers, setChatUsers] = useState([]);
  const [showLoadingAni, setShowLoadingAni] = useState(false);
  const [clientObj, setClientObj] = useState(null);
  const [openJukeboxPlaylist, setOpenJukeboxPlaylist] = useState(false);
  // const [appMode, setAppMode] = useState(appMode)
  const [showChatlist, setShowChatlist] = useState(false);
  const [chatHighlight, setChatHighlight] = useState(false);
  const [chatScreenHeader, setChatScreenHeader] = useState(false);

  const [mode, setMode] = useState("light");
  const ToggleSidebar = () => {
    isOpen === true ? setIsopen(false) : setIsopen(true);
  };

  const isLaunched = useIsVisible(ref);

  const setIsOpen = () => {
    // console.log("xsssdcdsfddscds");
  };

  ///////////////////////////////////////////////////// timer //

  const [timeLeft, setTimeLeft] = useState(initialTime);
  const timerRef = useRef(null);

  // Function to reset countdown
  const resetTimer = () => {
    clearInterval(timerRef.current); // Clear previous timer
    setTimeLeft(initialTime); // Reset time
    startTimer(); // Restart timer
  };

  // Start countdown
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const startTimer = () => {
    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current); // Stop at 0
          setShowChatlist(false);
          // console.log("showChatlist", showChatlist);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    startTimer();
    return () => {
      clearInterval(timerRef.current); // Cleanup on unmount
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //////////////////////////////////////

  useEffect(() => {
    const playerControlData = async () => {
      if (message) {
        const data = JSON.parse(message);
        if (data.highlightChatTab) {
          const highlightChatTab = JSON.parse(data.highlightChatTab);
          // console.log("**==** highlightChatTab", highlightChatTab);
          setChatHighlight(highlightChatTab);
        }
        if (data.highlightChatTab2) {
          const highlightChatTab2 = JSON.parse(data.highlightChatTab2);
          // console.log("**==** highlightChatTab2", highlightChatTab2);
          setChatHighlight(highlightChatTab2);
        }
      }
    };
    playerControlData();
  }, [message]);

  const signUserOut = async () => {
    //cookies.remove("auth-token");
    //cookies.remove("auth-token", {path: "/", domain: "muuzbox.com"})
    removeCookieWithPromise("auth-token", { path: "/" })
      .then(async () => {
        // console.log("Cookie removal complete. Now performing another task.");
        // Perform another task
        await signOut(auth);
        setIsAuth(false);
        setIsInChat(false);
        setIsInChat2(false);
        setIsInUsers(false);
      })
      .catch((error) => {
        console.error("Failed to remove cookie:", error);
      });
  };

  const removeCookieWithPromise = (cookieName, options = {}) => {
    return new Promise((resolve, reject) => {
      try {
        cookies.remove(cookieName, options); // Remove the cookie
        resolve(); // Resolve the promise
      } catch (error) {
        console.error("Error removing the cookie:", error);
        reject(error); // Reject the promise if there's an error
      }
    });
  };

  const closeAllPanels = () => {
    setShowLoadingAni(false);
    setIsInChat(false);
    setIsInChat2(false);
    setIsInUsers(false);
    setIsInJukebox(false);
    setIsInAutoPlay(false);
    setIsInHiddenChat(false);
    setIsInGames(false);
    setIsInChatV2(false);
    setIsopen(false);
  };
  // The rebuilt chat's own panel — see the isInChatV2 section in the render.
  const openChatV2Panel = () => {
    closeAllPanels();
    setShowLoadingAni(false);
    setIsInChatV2(true);
  };
  const pickedChat = (chatId, type, trackDetails, users) => {
    closeAllPanels();
    setIsInChat2(true);
    setChatId(chatId);
    setChatId2(null);
    setChatId2(chatId);
    setChatType(type);
    setTrackDetails(trackDetails);
    setChatUsers(users);
  };
  const loadingAni = () => {
    closeAllPanels();
    setShowLoadingAni(true);
  };
  const openUsersPanel = () => {
    closeAllPanels();
    setIsInUsers(true);
  };
  // Open a specific chat in the conversation window (which is hosted inside
  // Jukebox4). Closes other panels, switches to Jukebox4, and commands it via
  // the shared message channel to open this chat once it mounts. Lets the Users
  // panel land you straight in the conversation, like a normal chat app.
  const openChatById = (chatId, users) => {
    if (!chatId) return;
    closeAllPanels();
    setIsInJukebox(true);
    setMessage(
      JSON.stringify({ openChat: { chatId, users: users || [] }, at: Date.now() })
    );
  };
  const openJukeboxPanel = () => {
    closeAllPanels();
    if (window.location.hostname === "admin.muuzbox.com") {
      setIsInAutoPlay(true);
    } else {
      setIsInJukebox(true);
      setOpenJukeboxPlaylist(!openJukeboxPlaylist);
    }
  };
  const openAutoPlayPanel = () => {
    closeAllPanels();
    setIsInAutoPlay(true);
  };
  const openHiddenChatPanel = () => {
    closeAllPanels();
    setShowLoadingAni(false);
    setIsInHiddenChat(true);
  };
    // Muuzbox Madness Mondays — the guest's game-night surface. Same night doc
  // the gamesmaster console drives, so this layout and the admin PWA show
  // the identical room.
  const openGamesPanel = () => {
    // If the guest isn't a Google account yet (anonymous, or auth still
    // restoring), the Games flow will prompt Google sign-in from
    // LiveNightPanel.doJoin. On a phone that sign-in backgrounds the PWA and
    // the OS may kill + relaunch it, so the app boots fresh on the Jukebox.
    // Record the intent (localStorage — survives the relaunch, unlike
    // sessionStorage) so the mount effect below re-opens Games after sign-in.
    // (Anonymous guests CAN open Games to browse; only "Join Tonight"
    // triggers the upgrade.)
    if (!auth.currentUser || auth.currentUser.isAnonymous) {
      // Carry the venue too: the installed PWA's start_url has no #channel,
      // so a relaunch there needs the intent to restore which venue's game
      // night the guest was joining (App.js re-applies it to the hash).
      rememberPostLoginPanel('games', client || clientObj?.id || clientObj?.clientId || null);
    }
    closeAllPanels();
    setShowLoadingAni(false);
    setIsInGames(true);
  };
  const refreshChatList = () => {
    // setInChatList(false);
    // setTimeout(() => {
    //   setInChatList(true);
    // }, 300);
  };
  const sbm = (message) => {
    if (message === "sign out") signUserOut();
  };

  useEffect(() => {
    // console.log("appMode", appMode);
  }, [appMode]);

  useEffect(() => {
    // console.log('AppLayoutManuf effect')
    // Conditionally load ManufMuuzbox.scss based on hostname
    // if (window.location.hostname !== "admin.muuzbox.com") {
    //   import("../ManufMuuzbox.scss");
    // }
    // Add listener to update styles
    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", (e) =>
        onSelectMode(e.matches ? "dark" : "light")
      );

    // Setup dark/light mode for the first time
    onSelectMode(
      window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light"
    );

    // find the client uid
    const getClientObj = async () => {
      console.log("getClientObj", client);
      if (client) {
        const docRef = doc(db, "clients", client);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const Obj = {
            id: docSnap.id,
            clientId: docSnap.data().clientId,
            defaultPlaylist: docSnap.data().defaultPlaylist,
            avatarImage: docSnap.data().avatarImage,
            venueInfo: docSnap.data().venueInfo || {},
            events: docSnap.data().events || [],
            moodButtonDailyLimit:
              Number(docSnap.data().moodDailyLimit) || 1,
            // Desktop-controlled Now Playing layout (Settings toggle).
            // false/undefined = card layout; true = compact divided-row list.
            nowPlayingCompactLayout:
              docSnap.data().nowPlayingCompactLayout === true,
          };
          // console.log('Obj with moodButtonDailyLimit:', Obj.moodButtonDailyLimit, 'type:', typeof Obj.moodButtonDailyLimit);
          setClientObj(Obj);
        }
      } else if (window.location.hostname === "admin.muuzbox.com") {
        // console.log('getClientObj admin', window.location.hostname)
        // console.log('auth.currentUser.uid', auth.currentUser.uid)
        // const settings = async () => {
        const docRef = doc(db, "users", auth.currentUser.uid);
        const docSnap = await getDoc(docRef);
        console.log("docSnap", docSnap);
        try {
          if (docSnap.exists()) {
            const Obj = {
              clientId: docSnap.data().muuzboxAccountName.toLowerCase() || null,
            };
            // console.log('Obj', Obj);
            setClientObj(Obj);
          }
        } catch (err) {
          console.log("err", err);
        }

        // };
        // settings();
      }
    };
    // console.log('getClientObj')
    getClientObj();

    // Remove listener
    return () => {
      window
        .matchMedia("(prefers-color-scheme: dark)")
        .removeEventListener("change", () => {});
    };
  }, [client]);

  React.useEffect(() => {
    if (isLaunched) {
      //callbackFn(); // Trigger a function when the div is visible on view port
      setIsLaunched(true);
    }
  }, [isLaunched]);

    // Check for initial panel override from iframe embed (e.g. Search
  // Members). The post-Google-sign-in Games destination is handled by the
  // visible-instance gate below, NOT here — this mount effect also runs in
  // hidden duplicate instances.
  React.useEffect(() => {
    const initialPanel = sessionStorage.getItem('muuzbox_initial_panel');
    if (initialPanel) {
      sessionStorage.removeItem('muuzbox_initial_panel');
      if (initialPanel === 'users') {
        console.log('📌 Auto-opening Users panel from iframe param');
        setTimeout(() => openUsersPanel(), 800);
      }
      if (initialPanel === 'chatv2') {
        console.log('📌 Auto-opening the new chat panel from iframe param');
        setTimeout(() => openChatV2Panel(), 800);
      }
    }
  }, []);

  // Consume the pending post-sign-in games intent — the ONE reactive gate
  // for every flow (installed-PWA relaunch, in-page popup return, Android
  // Chrome→PWA handoff). Re-attempts whenever any signal that could change
  // the answer fires: this instance scrolling/being toggled into view
  // (isLaunched — the launcher shows the app section AFTER React mounts),
  // the tab returning to the foreground, or a Google (non-anonymous) uid
  // arriving. Only an instance that is actually on screen consumes — see
  // canThisInstanceConsume above for why hidden duplicates must not.
  const [gamesIntentTick, setGamesIntentTick] = useState(0);
  React.useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      if (u && !u.isAnonymous) setGamesIntentTick((t) => t + 1);
    });
    return unsub;
  }, []);
  React.useEffect(() => {
    const attempt = () => {
      if (!canThisInstanceConsume(ref.current)) return;
      if (consumePostLoginPanel()?.panel === 'games') {
        console.log('📌 Opening Games after sign-in/relaunch (visible instance)');
        // Small delay so the auth profile fetch has time to populate
        // userObject before Games reads it.
        setTimeout(() => openGamesPanel(), 300);
      }
    };
    // The launcher un-hides the app section ~500ms after DOM ready, which
    // IntersectionObserver (isLaunched) usually reports — the short retry
    // covers layouts where that signal never fires (e.g. static mounts the
    // observer misses) without polling forever.
    attempt();
    const retry = setTimeout(attempt, 1500);
    document.addEventListener('visibilitychange', attempt);
    return () => {
      clearTimeout(retry);
      document.removeEventListener('visibilitychange', attempt);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLaunched, gamesIntentTick]);

  const onSelectMode = (mode) => {
    setMode(mode);
    if (mode === "dark") {
      // document.body.classList.add('dark-mode')
      document.documentElement.setAttribute("data-theme", "dark");
      // console.log("dark mode");
    } else {
      // document.body.classList.remove('dark-mode')
      document.documentElement.setAttribute("data-theme", "light");
      // console.log("light mode");
    }
  };

  useEffect(() => {
    // Identity must FOLLOW the auth user. The old one-shot fetch (3s after
    // isAuth first flipped) meant that when the uid changed mid-session
    // (Google sign-in, anon upgrade/recovery) the request surfaces kept the
    // OLD profile while games read the new auth user live — "request page
    // says one user, games page says another". Subscribe instead and
    // re-fetch the users-doc profile on every uid change.
    let lastUid = null;
    let timer = null;
    const unsub = onAuthStateChanged(auth, (u) => {
      const uid = u?.uid || null;
      if (!uid || uid === lastUid) return;
      lastUid = uid;
      clearTimeout(timer);
      // Short delay so a freshly minted user's users/{uid} doc exists by the
      // time we read it (profile writes happen right after sign-in).
      timer = setTimeout(async () => {
        try {
          const userObj = await getUserDetails(uid);
          if (!userObj) return;
          setUserObject(userObj);
          setAvatars({ [uid]: userObj });

          // Send user info to parent window if embedded in iframe
          if (isEmbedded && window.parent !== window) {
            window.parent.postMessage({
              type: 'muuzbox-user-info',
              user: {
                displayName: userObj.displayName || 'Anonymous',
                photoURL: userObj.photoURL || null,
                email: userObj.email || null,
                uid
              }
            }, '*');
            console.log('📨 Sent user info to parent iframe');
          }
        } catch (err) {
          console.error("error", err);
        }
      }, 3000);
    });
    return () => { clearTimeout(timer); unsub(); };
  }, []);

  const getUserDetails = async (uid) => {
    const docRef = doc(db, "users", uid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      console.log("User details found:", docSnap.data());
      return {
        displayName: docSnap.data().displayName,
        photoURL: docSnap.data().photoURL,
        email: docSnap.data().email,
        nameChanged: docSnap.data().nameChanged || false,
        id: docSnap.id,
        bio: docSnap.data().bio,
        channel: docSnap.data().channel || "",
        points: docSnap.data().points || 0,
      };
    }
  };

  const getUserName = async (uid) => {
    const docRef = doc(db, "users", uid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const userObj = {
        displayName: docSnap.data().displayName,
        photoURL: docSnap.data().photoURL,
        email: docSnap.data().email,
        nameChanged: docSnap.data().nameChanged || false,
        id: docSnap.id,
        bio: docSnap.data().bio,
        channel: docSnap.data().channel || "",
      };
      console.log("User details found:", userObj.displayName);
      // setUserObject(userObj.displayName);
    }
  };

  useEffect(() => {
    if (chatType === "private") {
      // get the full list of uid for this chat first
      // plug that list into the avatar array
      // when the chat is created add all the participants
      // there first and retireve using getDoc(db, "chats", chatId)
      const chatsMessgesRef = collection(db, "chats", chatId3, "messages");
      const queryMessages = query(chatsMessgesRef, orderBy("createdAt"));
      const unsuscribe = onSnapshot(queryMessages, (snapshot) => {
        let messagesx = [];
        let avatars = [];
        snapshot.forEach((doc) => {
          // create an avatar list that can be referred to when the chatlist is rendered
          messagesx.push(Object.assign({ ...doc.data(), id: doc.id }));
        });

        new Promise(function (resolve, reject) {
          const avatarObj = {};
          const uniq = [...new Set(avatars)];
          // console.log("chatUsers", chatUsers);
          // make sure this current users avatar is index 0
          // find index of current user in this chatUsers array
          const currentUserIndex = chatUsers.findIndex(
            (item) => item.id === auth.currentUser.uid
          );
          if (currentUserIndex > -1) {
            chatUsers.unshift(chatUsers.splice(currentUserIndex, 1)[0]);
          }
          let i = 0;
          chatUsers.forEach((item) => {
            i++;
            avatarObj[item.id] = {
              displayName: item.displayName,
              photoURL: item.photoURL,
              email: item.email,
            };
          });
          console.log("who is it...", avatarObj);
          if (i >= uniq.length) resolve(avatarObj);
          else reject();
        }).then(function (avatarObj) {
          return new Promise((resolve, reject) => {
            setTimeout(() => resolve(setAvatars(avatarObj)), 300);
          });
        });
        // .then(function (result) {
        //   setMessages(messagesx);
        //   setTimeout(() => {
        //     updateWatchList(messagesx.length - 1);
        //     // zero this chatid in the chatlist as it is now being seen and rendered
        //   }, 2000);
        // });
      });
      // unmark a newchat
      const unmarknewRef = doc(
        db,
        "users",
        auth.currentUser.uid,
        "chats",
        chatId3
      );
      updateDoc(unmarknewRef, { newchat: 0 });
      refreshChatList();
      return () => unsuscribe();
    }
  }, [chatId3, chatType, clientObj, chatUsers]);

  if (!auth.currentUser) {
    <div>LOADING...</div>;
  }

  const UserName = () => {
    <div className="text-xs text-white">{auth?.currentUser?.displayName}</div>;
  };

  const openChatPanel = () => {
    setShowChatlist(!showChatlist);
    resetTimer();
  };

  const openVotePanel = (e) => {
    e.preventDefault();
    // console.log("openVotePanel", openVotePanel);
    // viewNextSong
    // the jukebox needs to be open in order for this message to get through, so open the jukebox first

    openJukeboxPanel();
    setTimeout(() => {
      const d = new Date();
      let seconds = d.getSeconds();
      const rand = Math.floor(Math.random() * seconds);
      // console.log("rand", rand);
      const viewNextSong = { viewNextSong: JSON.stringify(rand) };
      setMessage(JSON.stringify(viewNextSong));
    }, 2000);
  };

  const setChatHighlightTrigger = () => {
    // console.log("setChatHighlightTrigger");
    setChatHighlight(false);
  };

  const chatScreen = (users, chatid) => {
    // console.log("chatScreen", users);
    setChatUserObject(users);
    setChatUsers(users);
    setChatId3(chatid);
    setChatType("private");
    setChatScreenHeader(!chatScreenHeader);
    setTimeout(() => {}, 1000);
  };

  const closeChat = () => {
    setTimeout(() => {
      // console.log("closeChat");
      setShowChatlist(true);
    }, 2000);
  };

  const addChatToHiddenList = async (chatId) => {
    //read the chatid status and then toggle it
    // console.log("addChatToHiddenList", chatId);
    const hideRequestRef = doc(
      db,
      "users",
      auth.currentUser.uid,
      "chats",
      chatId
    );
    const docSnap = await getDoc(hideRequestRef);
    if (docSnap.exists()) {
      let status = "hidden";
      if (docSnap.data().status === "hidden") status = "";
      updateDoc(hideRequestRef, { status: status });
    } else {
      // error
    }
  };

  const ChatUser = ({ chatId }) => {
    let uid;
    for (const key in avatars) {
      if (avatars.hasOwnProperty(key)) {
        if (key !== auth.currentUser.uid) uid = key;
      }
    }

    return (
      <div className="flex flex-row items-center relative ml-12">
        {/* <div
          onClick={() => {
            openJukeboxPanel();
          }}
          className="muuzbox-section-button"
          style={{ left: "-24px", top: "8px" }}
        >


          <div
            id="notifyMuuzbox-close"
            className="close-muuzbox-btn ion-close"
          ></div>
        </div>
        <div className="relative flex flex-row items-center left-8">
          {uid && (
            <div className="flex items-center justify-center h-14 w-14 rounded-full border overflow-hidden ebzbg-indigo-500 flex-shrink-0 z-10 mr-3 ">
              <Avatar avObj={avatars} uid={uid} />
            </div>
          )}
          <div className="text-base">{avatars[uid]?.displayName}</div>
        </div> */}

        <button
          className="hide-chat nodecor"
          onClick={() => {
            addChatToHiddenList(chatId);
            closeChat();
            setChatScreenHeader(false);
          }}
        >
          <svg
            fill="#ffffff"
            width="20px"
            height="20px"
            viewBox="0 0 48 48"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0 0h48v48H0z" fill="none" />
            <g id="Shopicon">
              <path
                d="M11.957,33.215L7.172,38L10,40.828l5.305-5.305C17.867,36.992,20.788,38,24,38c12,0,20-14,20-14s-2.954-5.16-7.957-9.215
    L40.828,10L38,7.172l-5.305,5.305C30.133,11.008,27.212,10,24,10C12,10,4,24,4,24S6.954,29.16,11.957,33.215z M33.204,17.624
    c2.668,2.091,4.747,4.638,5.996,6.369C36.728,27.396,31.024,34,24,34c-2.048,0-3.973-0.563-5.742-1.43l1.684-1.684
    C21.133,31.589,22.517,32,24,32c4.418,0,8-3.582,8-8c0-1.483-0.411-2.867-1.114-4.058L33.204,17.624z M20.149,25.023
    C20.062,24.694,20,24.356,20,24c0-2.206,1.794-4,4-4c0.356,0,0.694,0.062,1.023,0.149L20.149,25.023z M27.851,22.977
    C27.938,23.306,28,23.644,28,24c0,2.206-1.794,4-4,4c-0.356,0-0.694-0.062-1.023-0.149L27.851,22.977z M24,14
    c2.048,0,3.973,0.563,5.742,1.43l-1.684,1.684C26.867,16.411,25.483,16,24,16c-4.418,0-8,3.582-8,8
    c0,1.483,0.411,2.867,1.114,4.058l-2.318,2.318c-2.668-2.091-4.747-4.638-5.997-6.369C11.272,20.604,16.976,14,24,14z"
              />
            </g>
          </svg>
        </button>
      </div>
    );
  };

  const getUserDisplayName = (uid) => {
    return avatars[uid]?.displayName || "Unknown User";
  };

  return (
    <div ref={ref} className={`Manuf bg-black ${isEmbedded ? 'embedded-mode' : ''}`}>
      {chatScreenHeader && (
        <div className="flex flex-row justify-between chatscreenheader">
          <div
            className="flex items-center cursor-pointer"
            onClick={() => {
              closeChat();
              setChatScreenHeader(false);
            }}
          >
            <svg
              fill="#FFFFFF"
              height="20px"
              width="20px"
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              enable-background="new 0 0 512 512"
            >
              <polygon points="213.3,205.3 213.3,77.3 0,248 213.3,418.7 213.3,290.7 512,290.7 512,205.3 " />
            </svg>
          </div>
          <div className="flex flex-row items-center">
            {chatUserObject[1].id && (
              <div className="flex items-center justify-center h-14 w-14 rounded-full border overflow-hidden bg-black ebzbg-indigo-500 flex-shrink-0 z-10 mr-3 ">
                <Avatar avObj={avatars} uid={chatUserObject[1].id} />
              </div>
            )}
            {chatUserObject[1].id && (
              <div className="flex items-center self-end z-10 ">
                <AvatarName avObj={avatars} uid={chatUserObject[1].id} />
              </div>
            )}
          </div>
          <ChatUser chatId={chatId3} />
        </div>
      )}
      {!chatScreenHeader && !isEmbedded && (
        <div className="flex flex-row justify-between max-w-full manuf-header"> {/* HEADER */}
          <SideBarMenu
            openUsersPanel={openUsersPanel}
            openJukeboxPanel={openJukeboxPanel}
            openAutoPlayPanel={openAutoPlayPanel}
            openHiddenChatPanel={openHiddenChatPanel}
            openGamesPanel={openGamesPanel}
            openChatV2Panel={openChatV2Panel}
            sbm={sbm}
            funcProp={funcProp}
            loadingAni={loadingAni}
            appMode={appMode}
            appLayoutMode={appLayoutMode}
          />
          <div class="flex flex-row items-center muuzbox-title">
            {/* <div className="muuzbox-wc-logo mr-2"></div> */}
            {/* <div className="text-4xl" style={{fontWeight: "500", fontSize: "25px"}}>MUUZBOX</div> */}
            <svg
              id="Layer_1"
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 2107.01 561.16"
              width="150px"
              height="40px"
            >
              <defs>
                <style
                  dangerouslySetInnerHTML={{
                    __html:
                      "\n                .cls-1 {\n                  fill: #fa163f;\n                }\n\n                .cls-2 {\n                  fill: #fff;\n                }\n\n                .cls-3 {\n                  fill: #2e6db5;\n                }\n              ",
                  }}
                />
              </defs>
              <path
                class="cls-1"
                d="m25.39,414l216.88,125.23V21.28L25.39,146.51v267.49Zm29.92-244.97l154.81-88.67v399.03l-28.42-16.29V129.14l-33.99,19.61v294.83l-28.5-16.29V164.96l-35.4,20.36v220.54h-1.5l-27.01-15.12v-221.7Z"
              />
              <polygon
                class="cls-3"
                points="333.52 278.8 333.52 278.72 333.19 278.72 333.19 429.13 431.08 372.95 431.08 290.6 397.42 278.8 333.52 278.8"
              />
              <path
                class="cls-3"
                d="m272.53,539.56l216.88-125.23V146.51L272.53,21.28v518.28Zm32.57-459.2l154.4,88.67v80.94l-24.02,12.22,24.02,8.48v118.91l-154.4,89.08V80.36Z"
              />
              <polygon
                class="cls-3"
                points="333.52 250.3 396.67 250.3 431.41 232.6 431.41 185.32 333.52 129.14 333.52 250.3"
              />
              <path
                class="cls-2"
                d="m459.5,270.66l-24.02-8.48,24.02-12.22v-80.94l-154.4-88.67v398.29l154.4-89.08v-118.91Zm-28.42,102.29l-97.89,56.17v-150.41h.33v.08h63.9l33.65,11.8v82.35Zm.33-140.35l-34.73,17.7h-63.15v-121.16l97.89,56.17v47.28Z"
              />
              <polygon
                class="cls-2"
                points="83.81 405.86 83.81 185.32 119.21 164.96 119.21 427.3 147.71 443.58 147.71 148.75 181.7 129.14 181.7 463.11 210.12 479.4 210.12 80.36 55.31 169.03 55.31 390.73 82.32 405.86 83.81 405.86"
              />
              <g>
                <path
                  class="cls-2"
                  d="m836.31,459.83h-49.8v-247.2l-51.6,247.2h-24l-54.2-247.2v247.2h-49.8V102.33h72l44,217.9,40.9-217.9h72.5v357.5h0Z"
                />
                <path
                  class="cls-2"
                  d="m998.61,102.33h53.8v241c0,33.3-2.2,56.5-7.1,69.4-7.1,19.1-19.6,33.3-36,42.2-12,6.7-25.8,9.8-40.5,9.8-26.7,0-47.6-9.3-62.7-28.5-10.2-12.9-16.5-26.7-18.7-41.8-1.8-13.8-2.7-31.1-2.7-51.6V101.83h53.8v235.2c0,31.1,1.3,50.2,3.6,56.9,4.4,13.3,13.3,20,26.7,20s23.6-8,27.6-23.6c1.8-6.7,2.7-24.5,2.7-53.8V101.33l-.4.9h-.1v.1Z"
                />
                <path
                  class="cls-2"
                  d="m1214.61,102.33h53.8v241c0,33.3-2.2,56.5-7.1,69.4-7.1,19.1-19.6,33.3-36,42.2-12,6.7-25.8,9.8-40.5,9.8-26.7,0-47.6-9.3-62.7-28.5-10.2-12.9-16.5-26.7-18.7-41.8-1.8-13.8-2.7-31.1-2.7-51.6V101.83h53.8v235.2c0,31.1,1.3,50.2,3.6,56.9,4.4,13.3,13.3,20,26.7,20s23.6-8,27.6-23.6c1.8-6.7,2.7-24.5,2.7-53.8V101.33l-.4.9h-.1v.1Z"
                />
                <path
                  class="cls-2"
                  d="m1467.21,409.53v49.8h-160.1v-49.8l103.6-257.4h-95.6v-49.8h152.5v49.8l-102.7,257.4h102.7-.4Z"
                />
                <path
                  class="cls-2"
                  d="m1505.01,459.83V102.33h74.3c24.5,0,43.1,4.9,56.9,15.1,21.3,15.6,32,41.3,32,77.4s-4.4,40.9-13.8,55.6c-5.3,8.9-13.3,16.9-24,24.5,11.6,6.2,20.5,12.9,25.8,20.9,11.6,16.5,17.3,39.1,17.3,68s-8.9,61.8-26.2,78.3c-8.9,8.4-19.1,13.8-30.7,15.6-8.9,1.8-20,2.2-33.3,2.2h-79.1.9-.1v-.1Zm53.8-209.9h11.1c14.7,0,25.3-3.1,31.6-8.9,9.8-8.9,14.7-24,14.7-44,0-29.8-12.4-44.5-37.3-44.5h-20v97.8-.4h-.1Zm0,159.6h20c14.2,0,24.5-3.6,30.7-10.2,8-8.4,11.6-22.2,11.6-41.8s-5.8-40.5-16.9-49.8c-6.2-5.3-16.9-8-32-8h-13.3v109.8h-.1Z"
                />
                <path
                  class="cls-2"
                  d="m1886.91,218.83v124.5c0,33.3-2.2,56.5-7.1,69.4-7.1,19.1-19.6,33.3-36,42.2-12,6.7-25.8,9.8-40.5,9.8-26.7,0-47.6-9.3-62.7-28.5-10.2-12.9-16.5-26.7-18.7-41.8-1.8-13.8-2.7-31.1-2.7-51.6v-124.5c0-33.3,2.2-56.9,7.1-69.8,7.1-18.7,19.6-32.9,36-42.2,12-6.7,25.8-9.8,40.5-9.8,26.7,0,47.6,9.3,62.7,28.5,10.2,12.9,16.5,26.7,18.2,41.8,1.8,13.8,2.7,31.1,2.7,51.6l.4.4h.1Zm-114.3,5.3v113.4c0,31.1,1.3,50.2,3.6,56.9,4.4,13.3,13.3,20,26.7,20s23.6-8,27.6-23.6c1.8-6.7,2.7-24.5,2.7-53.8v-113.4c0-31.1-1.3-50.2-3.6-56.9-4.9-13.3-13.8-20-27.1-20s-23.6,8-27.6,23.6c-1.8,6.7-2.7,24.9-2.7,53.8h.4Z"
                />
                <path
                  class="cls-2"
                  d="m2037.21,276.23l69.8,183.6h-56.5l-42.2-115.2-39.1,115.2h-55.6l67.1-183.6-64.5-173.8h56.5l37.3,105.4,34.7-105.4h55.6l-62.7,173.8h-.4Z"
                />
              </g>
            </svg>
            {/* <span>v 0.5.6</span> */}
          </div>
          <div className="flex flex-row items-center mr-4">
            <div
              onClick={openGamesPanel}
              style={{ cursor: "pointer" }}
              title="Games — Muuzbox Madness Mondays"
            >
              <svg
                height="24px"
                width="24px"
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 258.948 258.948"
              >
                <g>
                  <path
                    style={{ fill: "#FFFFFF" }}
                    d="M150.521,49.9c14.403-1.849,22.539-10.372,26.809-19.771c4.982-10.938-0.103-20.978-5.27-20.728
		c-5.167,0.234-8.523,7.386-12.439,14.278c-2.11,3.704-5.619,6.886-11.487,7.636c-25.939,3.334-31.617,24.449-30.997,35.397h18.71
		C135.732,63.34,136.444,51.722,150.521,49.9z"
                  />
                  <path
                    style={{ fill: "#FFFFFF" }}
                    d="M0.93,107.473c0,0-0.011,0.136-0.027,0.381C0.343,111.052,0,114.321,0,117.676
		c0,1.741,0.103,3.459,0.256,5.156c-0.936,36.741,0.984,126.67,42.267,126.719c51.872,0.065,57.823-71.045,57.823-71.045
		l29.132-0.022l29.126,0.022c0,0,5.95,71.105,57.823,71.045c41.283-0.054,43.197-89.984,42.267-126.725
		c0.147-1.697,0.256-3.416,0.256-5.156c0-3.35-0.348-6.625-0.903-9.823c-0.016-0.245-0.027-0.381-0.027-0.381l-0.033-0.011
		c-4.824-26.586-28.038-46.765-56.011-46.765c-13.962,0-26.738,5.042-36.643,13.375h-0.016h-11.814h-48.049H93.639h-0.016
		c-9.91-8.333-22.681-13.375-36.643-13.375c-27.973,0-51.187,20.179-56.011,46.765L0.93,107.473z M188.045,119.058
		c0-2.192,1.784-3.976,3.976-3.976h12.836V102.24c0-2.192,1.784-3.981,3.981-3.981h5.967c2.192,0,3.976,1.784,3.976,3.981v12.842
		h12.836c2.192,0,3.976,1.784,3.976,3.976v5.961c0,2.192-1.784,3.976-3.976,3.976h-12.836v12.842c0,2.192-1.784,3.981-3.976,3.981
		h-5.967c-2.192,0-3.981-1.784-3.981-3.981v-12.842h-12.836c-2.192,0-3.976-1.784-3.976-3.976V119.058z M68.951,114.233
		c4.313,0,7.811,3.497,7.811,7.811c0,4.313-3.497,7.811-7.811,7.811c-4.313,0-7.805-3.497-7.805-7.811
		C61.146,117.725,64.638,114.233,68.951,114.233z M50.893,97.394c4.313,0,7.81,3.497,7.81,7.811s-3.497,7.811-7.81,7.811
		s-7.805-3.497-7.805-7.811C43.083,100.886,46.58,97.394,50.893,97.394z M50.893,132.531c4.313,0,7.81,3.497,7.81,7.81
		c0,4.313-3.497,7.805-7.81,7.805s-7.805-3.497-7.805-7.805C43.083,136.028,46.58,132.531,50.893,132.531z M32.836,114.233
		c4.313,0,7.81,3.497,7.81,7.811c0,4.313-3.497,7.811-7.81,7.811s-7.805-3.497-7.805-7.811
		C25.025,117.725,28.522,114.233,32.836,114.233z"
                  />
                </g>
              </svg>
            </div>
            <div
              onClick={() => {
                appLayoutMode("newlayout");
              }}
            ></div>
          </div>
        </div>
      )}
      {/* App-wide video call overlay — rings on ANY panel while the app is
          open, and hosts the whole in-call UI. See components/VideoCall.js. */}
      {isAuth && <CallManager />}
      <div className="app-container max-w-full">
        {children}
        {isAuth && (
          <>
            {/* h-full, NOT h-screen: the section fills the REMAINDER of the
                .Manuf flex column (see ManufMuuzbox.scss shell geometry) —
                100vh here overflowed every host with chrome above the panels
                and clipped the bottom of games/chat unreachably. */}
            <section className="h-full overflow-hidden flex items-center justify-center max-w-full" style={{ minHeight: 0, flex: '1 1 auto' }}>
              <div className="flex h-full antialiased text-gray-800 dark:text-white w-full" style={{ minHeight: 0 }}>
                <div className="flex flex-row h-full w-full overflow-hidden">
                  {isInUsers && (
                    <Users4
                      refreshChatList={refreshChatList}
                      openChatById={openChatById}
                      setIsInUsers={setIsInUsers}
                    />
                  )}
                  {isInJukebox && clientObj && (
                    <Jukebox4
                      userObj={userObject}
                      clientObj={clientObj}
                      openJukeboxPlaylist={openJukeboxPlaylist}
                      showChatlist={showChatlist}
                      finishChat={!chatScreenHeader}
                      chatScreen={chatScreen}
                      isInUsers={isInUsers}
                      closeChat={closeChat}
                      setChatScreenHeader={setChatScreenHeader}
                      navigateToPlaying={navigateToPlaying}
                      setNavigateToPlaying={setNavigateToPlaying}
                    />
                  )}
                  {isInAutoPlay && clientObj?.clientId !== null && (
                    <AutoPlay userObj={userObject} clientObj={clientObj} />
                  )}
                  {isInGames && (
                    /* NO horizontal padding + overflow-x hidden (2026-09-12
                       bingo spec): the bingo card renders full-bleed via a
                       100vw breakout, and a y-scroller forces overflow-x to
                       auto — with side padding here the card scrolled
                       sideways INSIDE this box instead of reaching the
                       screen edges. Zero side padding = the breakout fits
                       exactly; the panel's own box keeps non-bingo content
                       inset. */
                    <div className="mbx-games w-full overflow-y-auto px-0 py-3" style={{ overflowX: 'hidden' }}>
                      <LiveNightPanel
                        channelName={clientObj?.id || clientObj?.clientId || null}
                        onOpenRequests={openJukeboxPanel}
                      />
                    </div>
                  )}
                  {/* Chat — the rebuilt surface, now THE chat (the legacy
                      ChatList/Chat/HiddenChatList stack is retired,
                      2026-08-31 verdict). isInHiddenChat routes here too so
                      any legacy My Chats caller lands on the new chat. */}
                  {(isInChatV2 || isInHiddenChat) && (
                    <div className="mbx-chat-v2 w-full flex flex-col" style={{ minHeight: 0 }}>
                      <div className="flex items-center gap-2 px-3 py-2.5 border-b border-white/10 flex-shrink-0 text-white">
                        <span className="text-lg font-bold" style={{ fontFamily: '"Syne", sans-serif' }}>Chat</span>
                      </div>
                      <div className="flex-1" style={{ minHeight: 0, overflow: 'hidden' }}>
                        <ChatV2 clientObj={clientObj} onOpenMembers={openUsersPanel} />
                      </div>
                    </div>
                  )}
                  {/* showLoadingAni */}
                  {showLoadingAni && <LoadingAnimation />}
                </div>
              </div>
            </section>
          </>
        )}
      </div>
    </div>
  );
};
